/* any functionality that external components need, and thus must be exported, goes in this file */
import { animationDurationInMS, colors, FadeInAnimation, font, ReduceMotion, spacing, zindex } from '@chegg-ui/theme';
import { css } from 'styled-components';

var getArrowSizeREM = function getArrowSizeREM() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "".concat(0.75 * multiplier, "rem");
}; // these styles are leveraged by the Toggletip component as well


export var getTooltipStyles = function getTooltipStyles(position, isShown, customTheme) {
  return css(["border-radius:", ";position:absolute;display:", ";box-sizing:initial;z-index:", ";flex-direction:column;line-height:", ";padding:", ";text-align:left;width:max-content;max-width:300px;font-family:", ";font-weight:", ";animation:", ";", " box-shadow:", ";background-color:", ";color:", ";& span:nth-child(2){font-weight:", ";margin-top:", ";display:block;}", " &::before{content:' ';height:", ";width:", ";background-color:inherit;position:absolute;transform:rotate(45deg);box-shadow:", ";", "}&::after{content:' ';height:", ";width:", ";background-color:inherit;position:absolute;", "}"], customTheme.borderRadius, isShown ? 'inline-flex' : 'none', zindex.tooltip, font.lineHeight.sm, customTheme.padding, font.family["default"], font.weight.bold, FadeInAnimation({
    duration: animationDurationInMS.slow
  }), ReduceMotion, customTheme.boxShadow, customTheme.tooltipBackgroundColor, colors.white, font.weight.normal, spacing.px8, function () {
    switch (position) {
      case 'top':
        return "\n            bottom: calc(100% + ".concat(getArrowSizeREM(), ");\n            left: calc(50%);\n            transform: translateX(-50%);\n          ");

      case 'topRight':
        return "\n            bottom: calc(100% + ".concat(getArrowSizeREM(), ");\n            left: 0;\n          ");

      case 'topLeft':
        return "\n            bottom: calc(100% + ".concat(getArrowSizeREM(), ");\n            right: 0;\n          ");

      case 'bottomRight':
        return "\n            top: calc(100% + ".concat(getArrowSizeREM(), ");\n            left: 0;\n          ");

      case 'bottom':
        return "\n            top: calc(100% + ".concat(getArrowSizeREM(), ");\n            left: calc(50%);\n            transform: translateX(-50%);\n          ");

      case 'bottomLeft':
        return "\n            top: calc(100% + ".concat(getArrowSizeREM(), ");\n            right: 0;\n          ");

      case 'left':
        return "\n            top: 50%;\n            right: calc(100% + ".concat(getArrowSizeREM(), ");\n            transform: translateY(-50%);\n          ");

      case 'right':
        return "\n            top: 50%;\n            left: calc(100% + ".concat(getArrowSizeREM(), ");\n            transform: translateY(-50%);\n          ");
    }
  }(), getArrowSizeREM(), getArrowSizeREM(), customTheme.boxShadow, function () {
    switch (position) {
      case 'top':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              left: calc(50% - ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'topRight':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              left: calc(0% + ").concat(getArrowSizeREM(), ");\n            ");

      case 'topLeft':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              right: calc(0% + ").concat(getArrowSizeREM(), ");\n            ");

      case 'bottomRight':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              left: calc(0% + ").concat(getArrowSizeREM(), ");\n            ");

      case 'bottom':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              left: calc(50% - ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'bottomLeft':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              right: calc(0% + ").concat(getArrowSizeREM(), ");\n            ");

      case 'left':
        return "\n              left: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              top: calc(50% - ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'right':
        return "\n              right: calc(100% - ".concat(getArrowSizeREM(0.5), ");\n              top: calc(50% - ").concat(getArrowSizeREM(0.5), ");]\n            ");
    }
  }(), getArrowSizeREM(customTheme.defaultPointerHeight), getArrowSizeREM(2), function () {
    switch (position) {
      case 'top':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              left: calc(50% - ").concat(getArrowSizeREM(), ");\n            ");

      case 'topRight':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              left: calc(0% + ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'topLeft':
        return "\n              top: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              right: calc(0% + ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'bottomRight':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              left: calc(0% + ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'bottom':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              left: calc(50% - ").concat(getArrowSizeREM(), ");\n            ");

      case 'bottomLeft':
        return "\n              bottom: calc(100% - ".concat(getArrowSizeREM(1.2), ");\n              right: calc(0% + ").concat(getArrowSizeREM(0.5), ");\n            ");

      case 'left':
        return "\n              height: ".concat(getArrowSizeREM(customTheme.rightLeftpointerHeight), ";\n              width: ").concat(getArrowSizeREM(1.2), ";\n              left: calc(100% - ").concat(getArrowSizeREM(1.2), ");\n              top: calc(50% - ").concat(getArrowSizeREM(), ");\n            ");

      case 'right':
        return "\n              height: ".concat(getArrowSizeREM(customTheme.rightLeftpointerHeight), ";\n              width: ").concat(getArrowSizeREM(1.2), ";\n              right: calc(100% - ").concat(getArrowSizeREM(1.2), ");\n              top: calc(50% - ").concat(getArrowSizeREM(), ");]\n            ");
    }
  }());
};
export var getTooltipPointerSpaceStyles = function getTooltipPointerSpaceStyles(position) {
  return css(["height:", ";width:100%;background-color:", ";position:absolute;", ""], getArrowSizeREM(), colors.transparent, function () {
    switch (position) {
      case 'topRight':
      case 'topLeft':
      case 'top':
        return "\n            top: 100%;\n            left: 0;\n          ";

      case 'bottomRight':
      case 'bottomLeft':
      case 'bottom':
        return "\n          bottom: 100%;\n          left: 0;\n          ";

      case 'left':
        return "\n            height: 100%;\n            width: ".concat(getArrowSizeREM(), ";\n            left: 100%;\n            top: 0;\n          ");

      case 'right':
        return "\n            height: 100%;\n            width: ".concat(getArrowSizeREM(), ";\n            right: 100%;\n            top: 0;\n          ");
    }
  }());
};
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        borderRadius: theme.radius.sm,
        padding: theme.spacing.xs,
        defaultPointerHeight: 0,
        rightLeftpointerHeight: 0,
        tooltipBackgroundColor: colors.grey950,
        tooltipTitleFontSize: theme.font.size.xs,
        boxShadow: theme.boxShadow.elevation400
      };
    },
    fanta: {
      borderRadius: '0',
      padding: spacing.px16,
      defaultPointerHeight: 1.2,
      rightLeftpointerHeight: 2,
      tooltipBackgroundColor: colors.dark,
      tooltipTitleFontSize: 'initial',
      boxShadow: '0 0 8px 0 rgba(34, 34, 34, 0.4)'
    },
    prop: themeProp
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/tooltip/dist/esm/externals.js
// module id = 658
// module chunks = 11